import { z } from 'zod'

/**
 * Shared validation schemas using Zod
 */

// Re-export intake schemas
export * from './intake'

// Re-export template schemas
export * from './template'

// Re-export clause schemas
export * from './clause'

// Re-export contract schemas
export * from './contract'

// Common field schemas
export const emailSchema = z.string().email('Email invalido')
export const phoneSchema = z.string().min(7, 'Telefono muy corto').max(20, 'Telefono muy largo')
export const idNumberSchema = z.string().min(5, 'Numero de identificacion muy corto')

// Pagination schema
export const paginationSchema = z.object({
  page: z.coerce.number().int().positive().default(1),
  limit: z.coerce.number().int().positive().max(100).default(20),
})
